/**
 * Merges multiple class names into a single string, ignoring undefined/blank values.
 *
 * @param classes - List of classes to merge
 * @returns A single string containing all valid class names
 */
export function classMerge(classes: (string | undefined)[]): string {
  return classes
    .map((c) => c?.trim())
    .filter(Boolean)
    .join(" ");
}
